module.exports = __webpack_public_path__ + "static/img/model-bg31.d93f9e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg31.jpg
// module id = DuhW
// module chunks = 0